import { scoreCount, scoreCountReaction } from "./scoreCounter";

//timeSpend is user spend time on single question
//totalTimeTaken is reaction test variable to check user tap reaction
export const answeredQues = (type, value, question, timeSpend) => {
  console.log("inanswer", "type", type);
  console.log("inanswer", "value", value);
  console.log("inanswer", "question", question);
  console.log("inanswer", "timeSpend", timeSpend);

  if (type === "choice_reaction") {
    return {
      answer: value,
      que_id: question.id,
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_score: scoreCountReaction(value.totalTimeTaken),
      que_time: !!value ? value.totalTimeTaken : 0,
      answer_flag: value.answer_flag,
      section_name: question.section_name,
    };
  } else if (type === "choice_reactionCal") {
    return {
      answer: value.totalTimeTaken,
      que_id: question.id,
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_score: scoreCountReaction(value.totalTimeTaken),
      que_time: !!value ? value.totalTimeTaken : 0,
      answer_flag: value.answer_flag,
      section_name: question.section_name,
    };
  } else if (type === "simple_reaction") {
    return {
      answer: value ? value : "",
      que_id: question.id,
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_score: scoreCountReaction(value.totalTimeTaken),
      que_time: !!value ? value.totalTimeTaken : 0,
      answer_flag: value.answer_flag,
      section_name: question.section_name,
    };
  } else if (type === "simple_reactionCal") {
    return {
      answer: value.totalTimeTaken,
      que_id: question.id,
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_score: scoreCountReaction(value.totalTimeTaken),
      que_time: !!value ? value.totalTimeTaken : 0,
      answer_flag: value.answer_flag,
      section_name: question.section_name,
    };
  } else if (type === "tap_letter") {
    return {
      answer: value.answer,
      que_id: value.que_id,
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_score: value.que_score,
      que_time: timeSpend,
      answer_flag: value.answer_flag,
      section_name: question.section_name,
    };
  } else if (type === "reverse_number_sequence") {
    // const myValue = !!value ? value.trim() : "";
    const { userInput, correctAttempts, wrongAttempts } = value;
    const myValue = userInput.trim();
    const totalScore = 100 / 4;
    let score = (totalScore * correctAttempts) / question.id;
    if (wrongAttempts == 0) {
      score = (score * 100) / 100;
    } else if (wrongAttempts == 1) {
      score = (score * 80) / 100;
    } else if (wrongAttempts == 2) {
      score = (score * 60) / 100;
    } else if (wrongAttempts == 3) {
      score = (score * 40) / 100;
    } else if (wrongAttempts == 4) {
      score = (score * 20) / 100;
    } else {
      score = 0;
    }
    return {
      answer: myValue,
      que_id: question.id,
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_score: score,
      que_time: timeSpend,
      section_name: question.section_name,
    };
  } else if (type === 'remember_the_numbers') {
    let correct = 0;
    let wrong = 0;
    const correctArray = question.correct_text?.split(',');
    value.forEach((item) => {
      if (correctArray.includes(item)) {
        correct++;
      } else {
        wrong++;
      }
    });

    const totalscore = 100 / 4;
    const score = (correct * totalscore) / question.id;

    return {
      answer: value.toString(),
      que_id: question.id,
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_score: score,
      que_time: Math.floor(timeSpend / 1000),
      section_name: question.section_name,
    }
  } else {
    const myValue = !!value ? value?.trim() : "";
    return {
      answer: myValue,
      que_id: question.id,
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_score: scoreCount(question, myValue),
      que_time: Math.floor(timeSpend / 1000),
      section_name: question.section_name,
    };
  }
};
